module.exports = __webpack_public_path__ + "build/img/hands2.b77c77a6.png";